// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:01:59

export default {
  "id": "daily-wordler",
  "slug": "daily-wordler",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/76696a6dfa6446feb73cf1fa6ecef4d1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/76696a6dfa6446feb73cf1fa6ecef4d1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Daily Wordler",
      "description": "Test your vocabulary and puzzle-solving skills with Daily Wordler, the ultimate word-guessing game that challenges your mind every day! With a simple yet addictive gameplay mechanic, Daily Wordler is perfect for fans of word games and brain teasers. \n\nYour goal is to guess the hidden word by entering valid words and using color-coded feedback to narrow down the solution. Yellow tiles indicate correct letters in the wrong position, while blue tiles signal correct letters in the right spot. ",
      "instructions": "Guess the hidden word using clever logic and feedback clues in the addictive and challenging Daily Wordler game!",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "crossword",
        "family",
        "logic",
        "skill",
        "thinking"
      ]
    },
    "zh-CN": {
      "title": "每日单词挑战者",
      "description": "测试你的词汇量和解谜技巧，与Daily Wordler一起玩这款终极猜词游戏，每天挑战你的大脑！Daily Wordler拥有简单却上瘾的游戏机制，非常适合喜欢文字游戏和脑力游戏的玩家。\n\n你的目标是通过输入有效的单词并利用颜色编码的反馈来缩小解决方案的范围，猜出隐藏的单词。黄色方块表示正确字母但在错误位置，而蓝色方块则表示正确字母在正确位置。",
      "instructions": "猜出隐藏的单词，利用巧妙的逻辑和反馈线索，在令人上瘾且具有挑战性的每日词谜游戏中！",
      "genres": [
        "谜题",
        "问答"
      ],
      "tags": [
        "填字游戏",
        "家庭",
        "逻辑",
        "技巧",
        "思考"
      ]
    },
    "zh-TW": {
      "title": "每日單詞者",
      "description": "測試你的詞彙和謎題解決技巧，與每日單字大師，這款最終的單字猜謎遊戲每天挑戰你的思維！透過簡單又上癮的遊戲機制，每日單字大師是詞遊和腦筋急轉彎愛好者的完美選擇。\n\n你的目標是透過輸入有效的單字，並使用顏色編碼的回饋來縮小解決方案範圍來猜出隱藏的單字。黃色圖塊表示正確的字母但位置錯誤，而藍色圖塊則表示正確的字母在正確的位置。",
      "instructions": "猜出隱藏的單詞，利用巧妙的邏輯和反饋提示，在令人上癮且挑戰性的《每日單詞》遊戲中！",
      "genres": [
        "謎題",
        "智力問答"
      ],
      "tags": [
        "十字字迷",
        "家庭",
        "邏輯",
        "技巧",
        "思考"
      ]
    },
    "zh-HK": {
      "title": "每日單詞者",
      "description": "測試你的詞彙和謎題解決技巧，與《每日Wordler》這款最終的猜字遊戲挑戰你的思維！遊戲玩法簡單而上癮，每日Wordler絕對適合喜歡文字遊戲和腦筋急轉的玩家。\n\n你的目標是透過輸入有效的單詞，並利用顏色編碼的回饋來縮小解決方案，來猜測隱藏的單詞。黃色磁磚表示正確的字母但位置錯誤，而藍色磁磚則表示正確的字母在正確的位置。",
      "instructions": "猜出隱藏的單詞，利用精妙的邏輯和反饋提示，在引人入勝且挑戰性極高的《每日單詞解謎》遊戲中！",
      "genres": [
        "謎題",
        "問答遊戲"
      ],
      "tags": [
        "字盤遊戲",
        "家庭",
        "邏輯",
        "技能",
        "思考"
      ]
    },
    "ja": {
      "title": "デイリーワードラー",
      "description": "Daily Wordlerであなたの単語力とパズル解きのスキルを試してみましょう。毎日新しい謎が脳を刺激する究極の単語推測ゲームです。シンプルで中毒性のあるゲームメカニクスで、単語ゲームや脳トレのファンには最適です。\n\nあなたの目標は、有効な単語を入力して、色コードされたフィードバックを使って解決策を絞り込むことで隠された単語を推測することです。黄色いタイルは正しい文字が間違った位置にあることを示し、青いタイルは正しい文字が正しい位置にあることを示します。",
      "instructions": "隠された単語を鋭い論理とフィードバッククルーズで当てて、魅力的で挑戦的なデイリー・ワードラーゲームを楽しみましょう！",
      "genres": [
        "パズル",
        "クイズ"
      ],
      "tags": [
        "クロスワード",
        "家族",
        "論理",
        "スキル",
        "思考"
      ]
    },
    "ko": {
      "title": "데이리 워드러",
      "description": "일일워드러의 단어력과 퍼즐 해결 능력을 테스트하세요! 매일 일어나는 뇌를 자극하는 최종 단어 추측 게임입니다! 간단하지만 약간에 취하게 만드는 게임 메커니즘으로, 단어 게임과 뇌 테이스터의 사랑받는 게임입니다.\n\n목표는 유효한 단어를 입력하고 색으로 표시된 피드백을 사용하여 해결책을 좁혀 나가는 숨겨진 단어를 추측하는 것입니다. 노란 타일은 틀린 위치에 있는 정확한 글자를, 파란 타일은 정확한 위치에 있는 글자를 나타냅니다.",
      "instructions": "숨겨진 단어를 매력적이고 도전적인 데일리 워들러 게임에서 지智者로서의 논리와 피드백 힌트를 사용하여 맞추세요!",
      "genres": [
        "퍼즐",
        "퀴즈"
      ],
      "tags": [
        "クロ스워드",
        "가족",
        "로직",
        "기술",
        "사고력"
      ]
    },
    "fr": {
      "title": "Daily Wordler",
      "description": "Testez votre vocabulaire et vos compétences en résolution de puzzles avec Daily Wordler, le jeu de devinette ultime qui sollicite votre esprit chaque jour ! Avec une mécanique de jeu simple mais addictive, Daily Wordler est parfait pour les fans de jeux de mots et de brain teasers.\n\nVotre objectif est de deviner le mot caché en saisissant des mots valides et en utilisant les retours codés en couleur pour affiner la solution. Les tuiles jaunes indiquent des lettres correctes à la mauvaise position, tandis que les tuiles bleues signalent des lettres correctes à la bonne place.",
      "instructions": "Devine le mot caché en utilisant une logique astucieuse et des indices de retour dans le jeu accrocheur et défiant Daily Wordler !",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "croixword",
        "famille",
        "logique",
        "compétence",
        "réflexion"
      ]
    }
  }
};
